import { getLanguageCode } from 'toolkit/utils';
import EN from './EN';
import DE from './DE';
import TR from './TR';

function Overview() {
  if (getLanguageCode() == 'tr-TR') {
    return (
      <>
        <TR />
      </>
    );
  } else if (getLanguageCode() == 'de-DE') {
    return (
      <>
        <DE />
      </>
    );
  } else
    return (
      <>
        <EN />
      </>
    );
}
export default Overview;
